import { useSelector } from 'react-redux'
import {
    createAsset,
    getAsset,
    getAssetById,
    searchFleet,
    updateAsset,
    getMakeAndModel,
} from '../repositories/FleetRepository'
import { useFleetActions } from '../store/slices/FleetSlice'

const useFleet = () => {
    const fleetFilters = useSelector(state => state.FleetSlice.fleetFilters)

    const { saveFleetFilters, resetAllFilters } = useFleetActions()

    const handleUpdateAsset = (data, onUpdated, onError) => {
        return updateAsset(data)
            .then(onUpdated)
            .catch(onError)
    }

    const handleGetAsset = (data, onGetted, onError) => {
        return getAsset(data)
            .then(onGetted)
            .catch(onError)
    }

    const handleGetAssetById = (data, onGetted, onError) => {
        return getAssetById(data)
            .then(onGetted)
            .catch(onError)
    }

    const handleSearchFleet = (params, onGetted, onError) => {
        return searchFleet(params)
            .then(onGetted)
            .catch(onError)
    }

    const handleCreateAsset = (data, onCreated, onError) => {
        return createAsset(data)
            .then(onCreated)
            .catch(onError)
    }

    const handleGetMakeAndModel = (onGetted, onError) => {
        return getMakeAndModel()
            .then(onGetted)
            .catch(onError)
    }

    return {
        handleUpdateAsset,
        handleGetAsset,
        handleSearchFleet,
        handleCreateAsset,
        saveFleetFilters,
        resetAllFilters,
        handleGetAssetById,
        handleGetMakeAndModel,
        fleetFilters: {
            ...fleetFilters,
            locationFilters: [...fleetFilters.locationFilters],
            equipmentFilters: [...fleetFilters.equipmentFilters],
            ownershipFilters: [...fleetFilters.ownershipFilters],
        },
    }
}

export default useFleet
